import React from 'react'
import { func, number, bool } from 'prop-types'

function DurationSection({
  duration, onDurationChange, isReadOnly, tagsLoading,
}) {
  return (
    <div className="promote-modal__summary-section">
      <div className="promote-modal__duration-controls">
        <div className="promote-modal__duration-header">
          <span className="promote-modal__summary-key">Duration</span>
          {!tagsLoading && (
            <span className="promote-modal__duration-value">{duration} day{duration !== 1 ? 's' : ''}</span>
          )}
        </div>
        {!isReadOnly && (
          <div className="promote-modal__slider-container">
            <span className="promote-modal__slider-label">1</span>
            <div className="promote-modal__slider-wrapper">
              <input
                type="range"
                min="1"
                max="30"
                value={duration}
                onChange={onDurationChange}
                className="promote-modal__slider"
              />
            </div>
            <span className="promote-modal__slider-label">30</span>
          </div>
        )}
      </div>
    </div>
  )
}

DurationSection.propTypes = {
  duration: number.isRequired,
  onDurationChange: func.isRequired,
  isReadOnly: bool.isRequired,
  tagsLoading: bool.isRequired,
}

export default DurationSection
